export enum LanguageEnum {
  CS = 'cs',
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  HU = 'hu',
  IT = 'it',
  NL = 'nl',
  PL = 'pl',
  SK = 'sk',
  HR = 'hr',
  SL = 'sl',
  DEFAULT = EN,
  FALLBACK = EN,
}

export const AVAILABLE_LANGUAGES = Object.values(LanguageEnum);

export enum BaseSiteEnum {
  GB = 'rentalGB',
  SK = 'rentalSK',
  PL = 'rentalPL',
  NL = 'rentalNL',
  LU = 'rentalLU',
  IT = 'rentalIT',
  HU = 'rentalHU',
  DE = 'rentalDE',
  CZ = 'rentalCZ',
  CH = 'rentalCH',
  BE = 'rentalBE',
  AT = 'rentalAT',
  HR = 'rentalHR',
  SI = 'rentalSI',
}
